import { render, staticRenderFns } from "./question-bank-category-tree.vue?vue&type=template&id=1e4be4c2&scoped=true&"
import script from "./question-bank-category-tree.vue?vue&type=script&lang=ts&"
export * from "./question-bank-category-tree.vue?vue&type=script&lang=ts&"
import style0 from "./question-bank-category-tree.vue?vue&type=style&index=0&id=1e4be4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4be4c2",
  null
  
)

export default component.exports